import { prepareNative } from './native/bootstrap';
// Native preparation runs before auth or synchronization can start.
void prepareNative().then(() => import('./main')).catch(error => {
  console.error('Goopa startup failed', error);
  const root = document.getElementById('root');
  if (root) root.textContent = 'Goopa non riesce ad avviarsi. Chiudi e riapri l’app. / Please restart Goopa.';
});
